import React from 'react'
import { useMatch, useNavigate } from 'react-router-dom'
import { ButtonIcon, Container, Content, SidemenuContainer } from './styles'
import { SystemWarnings } from './SystemWarnings'
import { DEFAULT_PATH, SEARCH_PATIENT_PATH } from '~/constants'
import { IconComponent } from '~/assets/icons/component'

interface ILayoutProps {
  children: React.ReactNode
}

export const Layout: React.FC<ILayoutProps> = ({ children }: ILayoutProps) => {
  const navigate = useNavigate()
  const isSearchPatientRoute = useMatch(`${DEFAULT_PATH}/${SEARCH_PATIENT_PATH}`)

  const handleNavigate = React.useCallback(
    (path: string) => {
      navigate(path)
    },
    [navigate]
  )

  return (
    <Container>
      <SidemenuContainer>
        <ButtonIcon onClick={() => handleNavigate(`${DEFAULT_PATH}/${SEARCH_PATIENT_PATH}`)}>
          <div>
            <IconComponent name={'home'} />
          </div>
        </ButtonIcon>
      </SidemenuContainer>
      <Content>
        {!isSearchPatientRoute && <SystemWarnings />}
        {children}
      </Content>
    </Container>
  )
}
